import { Component, Inject, OnInit, ViewChild } from '@angular/core';

import { RutaService } from '../../../../services/operaciones/ruta.service';
import { MatPaginator, MatSnackBar, MatTableDataSource } from '@angular/material';
import * as moment from 'moment/moment';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ExcelService } from 'src/app/services/excel.service';
import { Router } from '@angular/router';
import { DataService } from '../../../../utils/data.service';
import { utils } from '../../../../utils/utils';
import { modalComponent } from '../../../../utils/modal/modal.component';
import { EmbarqueModelo } from '../../../../models/embarque'
import { FormArray , FormBuilder, FormGroup, FormControl,Validators,  FormControlName ,AbstractControl } from '@angular/forms';
import {ReactiveFormsModule} from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import * as XLSX from 'xlsx'
import {MatFormFieldModule,MatFormFieldControl} from '@angular/material/form-field';
import { MatSelectFilterModule } from 'mat-select-filter';
import { ParadaService } from 'src/app/services/parada.service';
import { VehiculoTipoTransportista } from '../../programas/vehiculoTipoTransportista/vehiculoTipoTransportista.component';
import { TransportistaService } from 'src/app/services/configuracion/catalogos/operaciones/transportista/transportista.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { ConfiguracionWebService } from 'src/app/services/configuracionWeb.service';
import { AsignacionesDialog } from '../dialog-asignaciones/dialog-asignaciones.component';
import { ViajesService } from '../../../../services/viajes.service';

export const MY_FORMATS = {

  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },

};

@Component({
    selector: 'dialog-update-asignacion',
    templateUrl: '../dialog-update-asignacion/dialog-update-asignacion.component.html',
    styleUrls: ['../dialog-update-asignacion/dialog-update-asignacion.component.scss'],
    providers: [
      { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ]
  })
  
  export class DialogUpdateAsignacion implements OnInit {
    settings: Settings;
    public usuarioSession: any;
    public _utils : utils;
    public idRazonSocial: any;
    public idUsuario: any;
    public isZAM: any;            
    public idCliente: any;
    
    public listaRemolques = [];
    public listaRemolques2 = [];    
    public listaOperadores = [];
    
    paramATQDESPDIRECTO: any = false;//parametro de despacho.     
    
    idOperador = null;        
    idRemolque1 = null;
    idRemolque2 = null;
      
  constructor(
    public dialogRef: MatDialogRef<DialogUpdateAsignacion>,
    @Inject(MAT_DIALOG_DATA) public data:any,    
    public appSettings:AppSettings,
    public snackBar: MatSnackBar, 
    public dataService: DataService,
    public dialog: MatDialog,      
    public rutaService: RutaService,
    public paradaService: ParadaService,        
    private configuracionWebService: ConfiguracionWebService,
    private viajesService: ViajesService
    ) { 
      this.settings = this.appSettings.settings;
      this._utils = new utils();      
      console.log(data);      
    }
  
  ngOnInit(): void {    
    this.usuarioSession = JSON.parse(sessionStorage.getItem("usuario"));
    this.idRazonSocial = this.usuarioSession.idRazonSocial;
    this.isZAM = this.usuarioSession.activoZAM;    
    this.idCliente = this.data.idCliente;    

    this.consultarOperadores();    
    this.cargarRemolque();
    this.consultarDespDirecto();

    this.idOperador = this.data.idOperadorNum;
    this.idRemolque1 = this.data.idRemolque1;
    this.idRemolque2 = this.data.idRemolque2;
  }

  consultarDespDirecto(){
    //Obtiene el parametro de configuracion de autoquimicos 
    this.configuracionWebService.consultarParametro(this.idRazonSocial, "ATQDESPDIRECTO").subscribe(data => {
      if (data != null || data != undefined){
        if(data == "S"){
          this.paramATQDESPDIRECTO = true;
        }else{
          this.paramATQDESPDIRECTO = false;
        }
        console.log('paramATQDESPDIRECTO-> ',this.paramATQDESPDIRECTO);
      }      
    }), error => console.error(error);
  }

  cargarRemolque() {
    this.rutaService.consultarRemolques(this.idRazonSocial).subscribe(
      (data) => {
        if (data != null) {
          this.listaRemolques = data;
          this.listaRemolques2 = data;          
        }
      }, 
      (error) => {
        console.log(error);
      }
    )
  }

  consultarOperadores() {
    this.paradaService.consultarOperadores(this.idRazonSocial).subscribe(
      (data) => {
        if (data != null) {          
          this.listaOperadores = data;          
        }
      },
      (error) => {
        console.log(error);
      }
    )
  }  
  
  guardar(){
    if(!this.validaciones())
      return;    

    this.data.idOperador = this.idOperador
    this.data.idRemolque1 = this.idRemolque1
    this.data.idRemolque2 = this.idRemolque2
    //Actualizo la informacion en la BD
    this.viajesService.updateAsignacion(this.idOperador, this.idRemolque1 ? this.idRemolque1 : 0, this.idRemolque2 ? this.idRemolque1 : 0, this.data.idRuta).subscribe(
      (resp) => {
        this._utils.toast('Actualizado correctamente', this.snackBar);
        //Se termina de actualizar y cierro el modal
        this.dialogRef.close(true);
      },
      (error) => {
        this._utils.toast('Error al actualizar', this.snackBar);
      }
    )        
  }
  
  validaciones(){
    if(this.idOperador == null || this.idOperador == undefined || this.idOperador == 0 || this.idOperador.toString().trim() != ""){
      this._utils.toast('El Operador es requerido.', this.snackBar);
      return false      
    }

    if(this.idRemolque1 != null &&
        this.idRemolque1 != undefined &&
        this.idRemolque1 != 0 &&
        this.idRemolque1.toString() != "" &&
      
        this.idRemolque2 != null &&
        this.idRemolque2 != undefined &&
        this.idRemolque2 != 0 &&
        this.idRemolque2.toString() != ""
      ){
        if(this.idRemolque1 == this.idRemolque2){
          this._utils.toast('El remolque no puede ser el mismo', this.snackBar);
          return false      
        }
      }
    return true;
  }
  
}